import { render, staticRenderFns } from "./InstallGuide.vue?vue&type=template&id=52be6885&scoped=true&"
import script from "./InstallGuide.vue?vue&type=script&lang=js&"
export * from "./InstallGuide.vue?vue&type=script&lang=js&"
import style0 from "./InstallGuide.vue?vue&type=style&index=0&id=52be6885&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be6885",
  null
  
)

export default component.exports